import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'

const openGeocoder = require('node-open-geocoder')
const countryLookup = require('country-code-lookup')

const countryLookupSafe = (progName, param) => {
    try {
        return countryLookup[progName](param)
    } catch (err) {
        console.log(`safeRun- ${progName}-${param}-`, err.message)
        return null
    }
}

const cleanStreetAddress = address => {
    let addressParts = address.split(' ')
    //check first element and normalize number
    let addressNo = parseInt(addressParts[0])
    if (addressNo) {
        addressParts[0] = addressNo.toString()
    }
    return addressParts.join(' ')
}

const state = {
    location: {},
    locations: [],
    country: [],
    states: [],
    section: null,
    pagination: null,
}

const getters = {
    warehouse_sections(state) {
        return state.locations.reduce((_sections, location) => {
            if (location.is_warehouse)
                _sections.push(
                    ...location.sections.map(({ id, name }) => ({
                        id,
                        name: `${location.name}, ${name}`,
                    }))
                )
            return _sections
        }, [])
    },

    sections(state) {
        return (state.location || {}).sections || []
    },

    section_master_items(state) {
        const section = state.section || {}
        return section.master_items || []
    },

    locationSections(state) {
        return state.locations.reduce((_sections, _location) => {
            let xSections = [...(_location.sections || [])]
            const cleanedLocation = { ..._location }
            delete cleanedLocation.section
            xSections = xSections.map(x => {
                x.location = cleanedLocation
                return x
            })
            _sections = [..._sections, ...xSections]
            return _sections
        }, [])
    },

    simpleLocation(state) {
        const {
            id,
            created_at,
            updated_at,
            name,
            address1,
            address2,
            city,
            state_name,
            postal_code,
            zip_code,
            country_code,
            latitude,
            longitude,
            map_reference,
            is_warehouse,
        } = state.location
        return {
            id,
            created_at,
            updated_at,
            name,
            address1,
            address2,
            city,
            state_name,
            postal_code,
            zip_code,
            country_code,
            latitude,
            longitude,
            map_reference,
            is_warehouse,
        }
    },
}

const mutations = {
    SET_LOCATIONS(state, payload) {
        state.locations = payload
    },

    SET_LOCATION_PAGINATION(state, pag) {
        state.pagination = pag
    },

    SET_LOCATION(state, location) {
        state.location = location
    },

    SET_SECTION(state, section) {
        state.section = section
    },
    SET_COUNTRY(state, country) {
        state.country = country
    },
    SET_STATES(state, states) {
        state.states = states
    },
}

const actions = {
    ////location
    async fetchById(context, id) {
        try {
            if (id) {
                const resp = await axios.get(`location/${id}`)
                console.log('fetchById: location', resp.data.success.data)
                context.commit('SET_LOCATION', resp.data.success.data)
            } else {
                context.commit('SET_LOCATION', {})
            }
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchWarehouses(context) {
        try {
            const resp = await axios.get(`location/all_warehouses`)
            console.log('locations', resp)
            context.commit('SET_LOCATIONS', resp.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchCountry(context) {
        try {
            const resp = await axios.get(`country/dependent-dropdown`)
            // console.log('.......................', resp.data.countries)
            context.commit('SET_COUNTRY', resp.data.countries)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchstate(context, params) {
        try {
            const resp = await axios.post(
                `country/fetch-states?country_code=${params.country_code}`
            )
            context.commit('SET_STATES', resp.data.states)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchLocations(context, params) {
        try {
            // Destructure Params
            let { query, page: pg, filters } = params || {}

            // Initialize query params and filters if nothing is passed in
            query = query || ''
            pg = pg || 1
            filters = filters || {}

            // Fetch location data based on query params
            const path = `location?q=${query}&page=${pg}&${buildQuery(filters)}`
            const locationsData = await axios.get(path)

            // Destructure search data
            let {
                data,
                current_page: page,
                per_page: pageSize,
                total,
            } = locationsData.data.success.data

            console.log('fetchLocations results', data)

            // Create pagination object
            const pag = {
                page,
                pageSize,
                total,
            }

            context.commit('SET_LOCATIONS', data)
            context.commit('SET_LOCATION_PAGINATION', pag)
        } catch (err) {
            errorHandler(err)
        }
    },

    async create(context, { payload }) {
        try {
            console.log('create  payload', payload)
            const data = await axios.post(`location`, payload)
            console.log('create results', data)
            const { section, location } = data.data.success.data
            console.log('create results-section', section)
            console.log('create results-location', location)
            if (section) {
                context.commit('SET_SECTION', section)
            }
            // context.dispatch('fetchLocations') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, { id, payload }) {
        try {
            const data = await axios.put(`location/${id}`, payload)
            console.log('update results', data)
            // context.dispatch('fetchLocations') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async delete(context, id) {
        try {
            await axios.delete(`location/${id}`)
            // context.dispatch('fetchLocations') //not efficient
        } catch (err) {
            errorHandler(err)
        }
    },

    ////
    async getSection(_, location_section_id) {
        try {
            const path = `location/section-details/?id=${location_section_id}&items=0`
            const data = await axios.get(path)
            console.log('getSection results', data)
            return data.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async getSectionDetails(
        context,
        { location_section_id, include_master_items }
    ) {
        try {
            include_master_items = include_master_items ? 1 : 0
            const path = `location/section-details/?id=${location_section_id}&items=${include_master_items}`
            const data = await axios.get(path)
            console.log('getSectionDetails results', data)
            context.commit('SET_SECTION', data.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async createSection(context, { location_id, payload }) {
        try {
            console.log('create section   payload', payload)
            const path = `location/${location_id}/sections`
            console.log('create section   path', path)
            const data = await axios.post(path, payload)
            console.log('create section  results', data)
            context.commit('SET_SECTION', data.data.success.data)
            // context.dispatch('fetchLocations') //not efficient
            context.dispatch('fetchById', location_id)
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateSection(context, { id, location_id, payload }) {
        try {
            console.log('update section   payload', payload)
            const path = `location/${location_id}/sections/${id}/update`
            console.log('update section   path', path)
            const data = await axios.put(path, payload)
            console.log('update results', data)
            // context.dispatch('fetchLocations') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteSection(context, { id, location_id }) {
        try {
            const path = `location/${location_id}/sections/${id}/delete`
            console.log('delete section    path', path)
            const data = await axios.delete(path)
            console.log('update results', data)
            // context.dispatch('fetchLocations') //not efficient
            context.dispatch('fetchById', location_id)
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async geocodeAddress(
        { dispatch },
        { address1, address2, city, country_code }
    ) {

        try {
            const { country } = countryLookupSafe('byIso', country_code)
            const streetArray = [
                [address1, address2, city],
                [address1, city],
                [address2, city],
                [address1, address2],
                [address1],
                [address2],
            ]

            const doGeoCode = async arr => {
                if (arr.every(x => x)) {
                    const street = cleanStreetAddress(arr.join(', '))
                    return await dispatch('geocodeStreet', {
                        street,
                        country,
                    })
                }
            }
            let results = []
            for (let arr of streetArray) {
                results = [...results, ...((await doGeoCode(arr)) || [])]
            }
            console.log('geo results', results.length)
            const countryResults = results
                .filter(x => x.address.country === country)
                .map(x => {
                    x.importance = 1000 * parseFloat(x.importance)
                    return x
                })
            countryResults.sort((a, b) => b.importance - a.importance)
            console.log('countryResults', countryResults)
            if (countryResults.length === 0)
                throw new Error('Address Not Found')
            const { lat: latitude, lon: longitude } = countryResults[0]
            return {
                latitude,
                longitude,
            }
        } catch (err) {
            errorHandler(err)
        }
    },

    geocodeStreet(context, { street, country }) {
        return new Promise(resolve => {
            let q = `${street}, ${country}`
            console.log('map query:', q)
            openGeocoder({
                port: 443,
            })
            openGeocoder()
                .geocode(q)
                .end((err, res) => {
                    if (err) {
                        console.error('geocodeStreet--err', err)
                        //reject(err)
                        return resolve()
                    } else {
                        return resolve(res)
                    }
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}